import { NgModule } from '@angular/core';
import { AppAnalyticsDirective } from './app-analytics.directive';

@NgModule({
    declarations: [AppAnalyticsDirective],
    exports: [AppAnalyticsDirective],
})
export class AppAnalyticsModule {}
